<dashboardnav>

    <cradua-correspondencecompany
    [correspondenceCompanys]="correspondenceCompanys$ | async"
    (correspondenceCompany)="onSubmitCorrespondenceCompany($event)"
    (deleteCorrespondenceCompanyEvent)="onDeleteCorrespondenceCompany($event)"
    *ngIf="(isLoadingCorrespondenceCompany$ | async ) === false"
    >
  </cradua-correspondencecompany>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingCorrespondenceCompany$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
